var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpinner = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    fill: "none",
    viewBox: "0 0 70 70",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 6,
    d: "M12.284 57.665A32.14 32.14 0 0 1 3.39 40.032a32.3 32.3 0 0 1 3.065-19.547A31.86 31.86 0 0 1 20.307 6.49a31.4 31.4 0 0 1 19.349-3.096m18.06 8.94a32.14 32.14 0 0 1 8.894 17.634 32.3 32.3 0 0 1-3.065 19.548A31.86 31.86 0 0 1 49.693 63.51a31.4 31.4 0 0 1-19.348 3.096"
  })));
};
export { SvgSpinner as ReactComponent };